export default __webpack_public_path__ + "static/media/MINI.014bd3fb.png";